import React from "react";
import { Link } from 'react-router-dom';
import {
    CardBody,
    Row,
    Col,
    ModalBody,
} from "reactstrap";
// import { history } from '_helpers';

// import Datetime from "react-datetime";
import { connect } from 'react-redux';
// import { Redirect } from "react-router-dom";
// import * as moment from 'moment';
// import {
//   withScriptjs,
//   withGoogleMap,
//   GoogleMap,
//   Marker
// } from "react-google-maps";



class CelebEventHelpModal extends React.Component {
    constructor(props) {
        super(props);
        console.log("CelebEventHelpModal constructor()", props)
        this.state = {
        };
    }



    componentDidMount() {

    }


    render() {
        const { fees, streamlineMode } = this.props
        console.log("fees", fees)
        // let remit = num * ticket.price
        // let lvFee = remit * (liveNyteTicketPercentage/100) +
        //             num   * liveNyteTicketFlatFee
        // let stripeFee = (remit + lvFee + stripeFlatFee) / (1 - (stripePercentage/100)) - remit - lvFee
        // console.log("num", num, "remit", remit, "lvFee", lvFee, "stripeFee", stripeFee)

        return (
            <ModalBody>
                <Row>
                    <Col xs={12}>
                        <p className="text-left px-2 py-2">
                            {streamlineMode ? (
                                <>
                                    <h3 className="pt-3 text-underline">Inquiries</h3>
                                    <div className="title mb-2 text-muted">
                                        When you receive an inquiry, a chat channel opens between you and the event organizer.
                                    </div>
                                    <ul className="modal-list pl-3">
                                        <li>
                                            <b>No offer has been made yet.</b> Read the inquiry carefully and use the chat to clarify details, align expectations, and discuss pricing.
                                        </li>
                                        <li>
                                            If you don't have a schedule set up, you can send a <b>binding quote</b> that the event organizer can pay to book you.
                                        </li>
                                        <li>
                                            If you already have a schedule set up, the event organizer can send you a <b>binding offer</b>.
                                        </li>
                                        <li>
                                            Once an offer is sent, you can <span className="text-info title">accept</span> it to book the event or <span className="text-danger title">reject</span> the booking.
                                        </li>
                                    </ul>

                                    <h3 className="pt-3 text-underline">Offers</h3>
                                    <div className="title mb-2 text-muted">
                                        When you receive an offer, a chat channel opens between you and the event organizer—unless one was already created from an inquiry (e.g., a trusted event organizer sends an offer directly).
                                    </div>
                                    <ul className="modal-list pl-3">
                                        <li>
                                            Review the event details, read any available reviews, and communicate with the organizer to ensure expectations align.
                                        </li>
                                        <li>
                                            You can then <span className="text-info title">accept</span> the offer to confirm the booking or <span className="text-danger title">reject</span> it outright.
                                        </li>
                                    </ul>

                                    <h3 className="pt-3 text-underline">Bookings</h3>
                                    <ul className="modal-list pl-3">
                                        <li>
                                            View your upcoming bookings on the{" "}
                                            <Link to={{ pathname: `/dash/celeb-dashboard` }}>Dashboard</Link> by clicking "Upcoming Bookings".
                                        </li>
                                        <li>
                                            <span className="text-primary title">Booked events are highlighted in pink</span> on the calendar when the <span className="text-primary title">Booked</span> filter is enabled.
                                        </li>
                                    </ul>

                                    <h3 className="pt-3 text-underline">Payouts</h3>
                                    <ul className="modal-list pl-3">
                                        <li>
                                            You can find your payouts on the{" "}
                                            <Link to={{ pathname: `/dash/payments` }}>Payments</Link> page.
                                        </li>
                                    </ul>
                                </>

                            ) : (
                                <>
                                    <>
                                        <h3 className="pb-3 text-underline">Bids</h3>

                                        <div className="pl-3">
                                            <div className="pb-3">
                                                <span className="text-info title">• Bids</span> are highlighted in blue on the Calendar by checking the{" "}
                                                <span className="text-info title">Bid</span> box.
                                            </div>
                                            <div className="pb-3">
                                                <b>*</b> If you have <b>Approve Bids</b> enabled in your schedule,{" "}
                                                <u className="text-purple">you will receive bid requests first</u>.
                                            </div>
                                            <div className="pb-3">
                                                • When you receive a bid request, you can{" "}
                                                <span className="text-info title">approve</span> or{" "}
                                                <span className="text-danger title">reject</span> the bid.
                                            </div>
                                            <div className="pb-3">
                                                • We recommend reading reviews and communicating with the bidder to ensure your expectations align.
                                            </div>
                                            <div className="pb-3">
                                                • New bid requests can be found on your{" "}
                                                <Link to={{ pathname: `/dash/celeb-dashboard` }}>Dashboard</Link> by clicking the "Bid Requests" button.
                                            </div>
                                            <div className="pb-3">
                                                • You can also find bid requests{" "}
                                                <span className="text-purple title">highlighted in purple</span> on the calendar by checking the{" "}
                                                <span className="text-purple title">Request</span> box.
                                            </div>
                                        </div>

                                        <h3 className="pb-3 text-underline">Bookings</h3>

                                        <div className="pb-3">
                                            Once your schedule closes, LiveNyte will optimize your active bids by booking those that maximize revenue
                                            and minimize driving distance across all your schedules for that day.
                                        </div>

                                        <div className="pb-3">
                                            You can also get booked for events before your schedule closes by using <i>Book early</i> or if a business uses{" "}
                                            <i>Book Now</i>.
                                        </div>

                                        <div className="pl-3">
                                            <div className="pb-3">
                                                • Find your upcoming bookings on the{" "}
                                                <Link to={{ pathname: `/dash/celeb-dashboard` }}>Dashboard</Link> by clicking the "Upcoming Bookings" button.
                                            </div>
                                            <div className="pb-3">
                                                • Upcoming bookings are also{" "}
                                                <span className="text-success primary">highlighted in pink</span> on the calendar by checking the{" "}
                                                <span className="text-primary title">Booked</span> box.
                                            </div>
                                        </div>

                                        <h3 className="pb-3 text-underline">Payouts</h3>

                                        <div className="pb-3">
                                            You can find your payouts on the{" "}
                                            <Link to={{ pathname: `/dash/payments` }}>Payments</Link> page.
                                        </div>
                                    </>
                                </>
                            )}
                        </p>
                    </Col>
                </Row>
            </ModalBody>
        );
    }
}

function mapStateToProps(state) {
    const { feesData, systemData } = state;
    const { fees, fetchingFees } = feesData;
    const { streamlineMode } = systemData
    return {
        fees, fetchingFees,
        streamlineMode
    };
}

const connectedCelebEventHelpModal = connect(mapStateToProps)(CelebEventHelpModal);
export { connectedCelebEventHelpModal as CelebEventHelpModal }; 